import React, { useState } from 'react';
import reactStringReplace from 'react-string-replace';
import { GetAppSettings, GoFormzServices } from '../AppSettings';
import Loader from '../components/loader';
import { analyticsTrack } from '../helpers/AnalyticsUtility';
import { useApimPost } from '../hooks/useApi';
import { faqQuery } from './helpers';
import { ExpandCollapseIcon } from './Icons';
import { FAQItem as FAQItemType, FAQPage, FAQResponse } from './successlauncher-types';

export interface FAQsProps {
  page: FAQPage;
}

export default function FAQs(props: FAQsProps) {
  const { page } = props;
  const { CmsEnvironment } = GetAppSettings();
  const query = faqQuery(page);
  const [faqReponse, isLoading] = useApimPost<FAQResponse>(GoFormzServices.CmsService, `/cms/graphql`, query);

  return (
    <div className="faqs">
      <h2>Frequently Asked Questions</h2>
      {isLoading ? (
        <Loader isLoading />
      ) : (
        faqReponse.data.SL_FAQ.filter((x) => x.Environment?.some((env) => env === CmsEnvironment)).map((x, i) => (
          <FAQItem key={i} faqItem={x} position={x.Position} />
        ))
      )}
    </div>
  );
}

interface FAQItemProps {
  faqItem: FAQItemType;
  position: number;
}

function FAQItem(props: FAQItemProps) {
  const { faqItem, position } = props;
  const [expanded, setExpanded] = useState(false);

  const toggleItem = () => {
    if (!expanded) {
      analyticsTrack('Success Launcher FAQ Clicked', {
        question: faqItem.Question,
        position: position
      });
    }
    setExpanded(!expanded);
  };

  return (
    <div className="faq-item">
      <div className={`expand-icon ${expanded ? 'expanded' : 'collapsed'}`} onClick={() => toggleItem()} tabIndex={-1}>
        <ExpandCollapseIcon />
      </div>
      <button className="question-text plain-button" onClick={() => toggleItem()}>
        {faqItem.Question}
      </button>
      {expanded ? (
        <div className="answer-text">
          {reactStringReplace(faqItem.Answer, /(\n)/g, (match, i) => (
            <br key={i} />
          ))}
          {faqItem.Link ? (
            <>
              {' '}
              <a href={faqItem.Link} target="_blank" className="more-info">
                More Info
              </a>
            </>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
